"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderUiSchema = void 0;
const reorderUiSchema = (templateInfo) => {
    if (!(templateInfo === null || templateInfo === void 0 ? void 0 : templateInfo.form))
        return null;
    const elements = templateInfo === null || templateInfo === void 0 ? void 0 : templateInfo.form.uiSchema.elements;
    const notesElement = elements.find((element) => element.scope === "#/properties/notes");
    const reorderedElements = elements.filter((element) => element.scope !== "#/properties/notes");
    notesElement && reorderedElements.push(notesElement);
    return Object.assign(Object.assign({}, templateInfo === null || templateInfo === void 0 ? void 0 : templateInfo.form.uiSchema), { elements: reorderedElements });
};
exports.reorderUiSchema = reorderUiSchema;
